import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { handleError, handleSuccess } from '../utils';

function Profile({ setIsAuthenticated }) {
    const [userProfile, setUserProfile] = useState(null);
    const navigate = useNavigate();
    const location = useLocation();
    const backendUrl = process.env.REACT_APP_BACKEND_URL;

    const handleLogout = useCallback(() => {
        localStorage.removeItem('token');
        setIsAuthenticated(false);
        handleSuccess('You have been logged out.');
        navigate('/login');
    }, [navigate, setIsAuthenticated]);

    useEffect(() => {
        if (location.state?.userProfile) {
            setUserProfile(location.state.userProfile);
        } else {
            const fetchProfile = async () => {
                try {
                    const url = `${backendUrl}/profile/profile`;
                    const token = localStorage.getItem('token');
                    if (!token) {
                        handleLogout();
                        return;
                    }
                    
                    const response = await fetch(url, {
                        headers: { 'Authorization': `Bearer ${token}` }
                    });
                    const result = await response.json();

                    if (response.ok) {
                        setUserProfile(result.data);
                    } else {
                        handleError(result.message || "Session expired. Please log in again.");
                        handleLogout();
                    }
                } catch (err) {
                    handleError("Failed to fetch profile.");
                    handleLogout();
                }
            };
            fetchProfile();
        }
    // --- THIS IS THE FINAL FIX ---
    // Add 'backendUrl' to this array to solve the error.
    }, [handleLogout, location.state, backendUrl]);

    return (
        <div className='container'>
            {userProfile ? (
                <div className='profile-card'>
                    <h1>Welcome!</h1>
                    <h2>Student Profile</h2>
                    <p><strong>Registration No:</strong> {userProfile.registrationNumber}</p>
                    <p><strong>Registered Phone:</strong> {userProfile.phone.split('@')[0]}</p>
                    <p><strong>Joined On:</strong> {new Date(userProfile.joinedOn).toLocaleDateString()}</p>
                    <button onClick={handleLogout}>Logout</button>
                </div>
            ) : (
                <p>Loading profile...</p>
            )}
        </div>
    );
}

export default Profile;
